module.exports = "/fonts/NeoSansStd-Light.woff2?0d70dcbef5e122633c68444fb9410e2b";